export default "__VITE_ASSET__sP$$5ZO___"